/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    }
  },
  rules: [
    {
      if: { hover: true },
      tokens: { borderColor: '#414547', iconColor: '#414547' }
    },
    {
      if: { pressed: true },
      tokens: { backgroundColor: '#676e73', iconColor: '#ffffff' }
    }
  ],
  tokens: {
    backgroundColor: '#ffffff',
    borderColor: '#b2b9bf',
    borderRadius: 32,
    borderWidth: 1,
    iconColor: '#676e73',
    iconScale: 1,
    iconSize: 16,
    iconTranslateX: 0,
    iconTranslateY: 0,
    outerBorderColor: 'transparent',
    outerBorderGap: 0,
    outerBorderWidth: 0,
    padding: 8,
    shadow: {
      blur: 2,
      color: 'rgba(0, 0, 0, 0.2)',
      inset: false,
      offsetX: 0,
      offsetY: 2,
      spread: 0
    }
  }
}
export default theme
